<template>
  <div class="animated revealUp">
    <div class="white-wrapper mt-4">
      <div
        class="section-title mb-4"
      >{{ $t('filmwisecollectionreport') }}</div>

      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- SELECT CINEMA -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="getFilmCollectionReportSelectedCinema ? 'shift-up':''"
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
              <b-dropdown
                :text="getFilmCollectionReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getCinemasList"
                  :key="dropdownIndex"
                  @click="onFilmCollectionReportDropdownHandler({ event: $event, name:'Cinema',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <!-- START DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getFilmCollectionReportFromDate"
                  v-on:click="onFilmCollectionReportDateHandler({ event: null, name: 'fromDate' })"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  :value="getFilmCollectionReportFromDate"
                  @selected="onFilmCollectionReportDateHandler({ event: $event, name: 'fromDate' })"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getFilmCollectionReportFromDate ? 'active': ''"
                >{{ $t('show') }} {{ $t('fromdate') }}</label>
              </div>
            </div>
          </div>

          <!-- END DATE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getFilmCollectionReportToDate"
                  v-on:click="onFilmCollectionReportDateHandler({ event: null, name: 'toDate' })"
                >✖</button>
                <Datepicker :monday-first="true"
                  ref="programaticOpen"
                  :value="getFilmCollectionReportToDate"
                  @selected="onFilmCollectionReportDateHandler({ event: $event, name: 'toDate' })"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getFilmCollectionReportToDate ? 'active': ''"
                >{{ $t('show') }} {{ $t('todate') }}</label>
              </div>
            </div>
          </div>

          <!-- SELECT DISTRIBUTOR -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="getFilmCollectionReportSelectedDistributor ? 'shift-up': ''"
              >{{ $tc('distributor', 1) }}</label>
              <b-dropdown
                :text="getFilmCollectionReportSelectedDistributor"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorsList"
                  :key="dropdownIndex"
                  @click="onFilmCollectionReportDropdownHandler({ event: $event, name:'Distributor',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.d_company_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <!-- SELECT CINEMA -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="getFilmCollectionReportSelectedMovie ? 'shift-up':''"
              >{{ $tc('movie', 1) }}</label>
              <b-dropdown
                :text="getFilmCollectionReportSelectedMovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorsMasterMovieList"
                  :key="dropdownIndex"
                  @click="onFilmCollectionReportDropdownHandler({ event: $event, name:'MasterMovie',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.movie_title }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              @click.prevent.stop="fetchFilmCollectionReportListv2"
              class="btn-blue-lg w-100"
            >{{ $tc('fetch') }} {{ $tc('report') }}</button>
          </div>
        </div>
      </div>

      <div v-if="getFilmCollectionReportList.length === 0" class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="bg-lightgrey">{{ $tc('screen', 1) }}</th>
              <th class="bg-lightgrey">{{ $t('show') }} {{ $t('time') }}</th>
              <th class="bg-lightgrey">{{ $tc('category', 1) }}</th>
              <th class="bg-lightgrey">{{ $t('class') }}</th>
              <th class="bg-lightgrey">{{ $t('rate') }}</th>
              <th class="bg-lightgrey">{{ $t('sold') }}</th>
              <th class="bg-lightgrey">{{ $t('sold') }} {{ $t('amount') }}</th>
              <th class="bg-lightgrey">{{ $t('tax') }}</th>
              <th class="bg-lightgrey">{{ $t('net') }} {{ $t('amount') }}</th>
            </tr>
          </thead>

          <tr>
            <td colspan="9">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
          <!-- <tr class="text-right bg-lightgrey">
            <th colspan="4">Total od VALMIKI (2D) (Telugu) (15+)</th>
            <th></th>
            <th>36</th>
            <th>1,187.03</th>
            <th>56.53</th>
            <th>1,073.98</th>
          </tr>
          <tr class="text-right bg-lightgrey">
            <th colspan="4">Grand Total</th>
            <th></th>
            <th>4167</th>
            <th>187,202.01</th>
            <th>8,914.38</th>
            <th>169,373.25</th>
          </tr>-->
        </table>
      </div>

      <div v-if="getFilmCollectionReportList.length > 0" class="swc-report">
        <table
          v-for="(FilmCollection , FilmCollectionIndex) in getFilmCollectionReportList"
          :key="FilmCollectionIndex+'Film'"
          class="swc-report-table"
          border="1"
        >
          <thead v-if="FilmCollectionIndex ==0">
            <tr>
              <th class="bg-lightgrey">{{ $tc('screen', 1) }}</th>
              <th class="bg-lightgrey">{{ $t('show') }} {{ $t('time') }}</th>
              <th class="bg-lightgrey">{{ $tc('category', 1) }}</th>
              <th class="bg-lightgrey">{{ $t('class') }}</th>
              <th class="bg-lightgrey">{{ $t('rate') }}</th>
              <th class="bg-lightgrey">{{ $t('sold') }}</th>
              <th class="bg-lightgrey">{{ $t('gross') }} {{ $t('amount') }}</th>

              <th
                v-for="(FilmCollectionReportCharge, FilmCollectionReportChargeIndex) in getFilmCollectionReportChargeList"
                :key="FilmCollectionReportChargeIndex"
                class="bg-lightgrey"
              >{{ FilmCollectionReportCharge.ct_name }}</th>
              <!-- <th class="bg-lightgrey">M.Tax</th>
              <th class="bg-lightgrey">Tax</th>-->
              <th class="bg-lightgrey">{{ $t('net') }} {{ $t('amount') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                v-if="FilmCollectionIndex !== 0"
                :colspan="8+getFilmCollectionReportChargeList.length"
              >
                <div class="p-3"></div>
              </td>
            </tr>
            <tr>
              <td :colspan="8+getFilmCollectionReportChargeList.length" class="p-0">
                <div
                  class="bg-lightgrey d-flex w-100 justify-content-between p-2 border-top border-dark"
                >
                  <div>
                    <strong>{{ FilmCollection[0].Data[0].movie_name }}</strong>
                  </div>
                  <div>
                    <strong>{{ $tc('distributor', 1) }} : {{ getFilmCollectionReportSelectedDistributor }}</strong>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-for="(Screen, ScreenIndex) in FilmCollection" :key="ScreenIndex">
            <tr v-for="(Show, ShowIndex) in Screen.Data" :key="ShowIndex+Show.screen_name">
              <td>{{ Show.screen_name }}</td>
              <td>{{ Show.t_show_time }}</td>
              <td>{{ Show.shift_name }}</td>
              <td>{{ Show.seat_type_name }}</td>
              <td>{{ Show.rate }}</td>
              <!-- <td>{{ Show['ShowNo'] ? Show['ShowNo'] : '-' }}</td>
              <td>{{ Show['Amount'] ? Show['Amount'] : '-' }}</td>-->
              <td>{{ Show.Sold }}</td>
              <td>{{ Show.gross_amount }}</td>
              <!-- <td
                v-for="(ChargeItem, ChargeIndex) in Show.taxes"
                :key="ChargeIndex+ChargeItem.ChargeName+ChargeItem.ct_name"
              >
                <div>&nbsp;</div>
                <div>{{ ChargeItem['SUM(ts.sp_value)'] }}</div>
              </td>-->
              <td
                v-for="(FilmCollectionReportCharge, FilmCollectionReportChargeIndex) in getFilmCollectionReportChargeList"
                :key="FilmCollectionReportChargeIndex"
              >{{ Show[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id]? (Show[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id]).toFixed(this.MIN_FRACTION_DIGITS) || '-' : '_' }}</td>
              <!-- <td>H-85.00</td>
              <td>H-85.00</td>-->
              <td>{{ (parseFloat(Show.t_net_amount) * parseFloat(Show.Sold)).toFixed(this.MIN_FRACTION_DIGITS) || '-' }}</td>
            </tr>

            <tr>
              <td class="bg-lightgrey" colspan="4">
                <strong>{{ $t('total') }} {{ $t('of') }} {{ Screen.t_show_time }}</strong>
              </td>
              <td class="bg-lightgrey"></td>
              <td
                class="bg-lightgrey"
              >{{ Screen.Data.reduce((accumulator, { Sold }) => accumulator + parseFloat(Sold),0).toFixed(this.MIN_FRACTION_DIGITS) || "-" }}</td>
              <td
                class="bg-lightgrey"
              >{{ Screen.Data.reduce((accumulator, { gross_amount }) => accumulator + parseFloat(gross_amount),0).toFixed(this.MIN_FRACTION_DIGITS) || '-' }}</td>
              <td
                v-for="(FilmCollectionReportCharge, FilmCollectionReportChargeIndex) in getFilmCollectionReportChargeList"
                :key="FilmCollectionReportChargeIndex+'_Charges'"
                class="bg-lightgrey"
              >
                {{ Screen.Data.reduce((accumulator, obj)=> accumulator + (obj[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id]==null?obj[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id]=0:obj[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id] ),0).toFixed(this.MIN_FRACTION_DIGITS)==='0.00'?"-": Screen.Data.reduce((accumulator, obj)=> accumulator + (obj[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id]==null?obj[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id]=0:obj[FilmCollectionReportCharge.ct_name+'_'+FilmCollectionReportCharge.ct_id] ),0).toFixed(this.MIN_FRACTION_DIGITS)}}
                <!-- <td class="bg-lightgrey">85.00</td>
                <td class="bg-lightgrey">85.00</td>-->
              </td>
              <td
                class="bg-lightgrey"
              >{{ Screen.Data.reduce((accumulator, { t_net_amount, Sold })=> accumulator + (parseFloat(t_net_amount) * parseFloat(Sold)),0).toFixed(this.MIN_FRACTION_DIGITS) || '-' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-end mt-5 align-items-center">
          <div>{{ $t('download') }} as:</div>
          <a
            v-if="getFilmCollectionPDFFileName"
            :href="BASE_URL+getFilmCollectionPDFFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a
            v-if="getFilmCollectionExcelFileName"
            :href="BASE_URL+getFilmCollectionExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";

export default {
  data() {
    return {
      BASEURL
    };
  },
  computed: {
    ...mapGetters([
      // Flags
      "getFilmCollectionReportsIsCinema",
      // End
      // DropDownList
      "getDistributorsList",
      "getCinemasList",
      // "getFilmCollectionReportMoviesList",
      "getDistributorsMasterMovieList",
      "getFilmCollectionReportChargeList",
      // DropDown
      "getFilmCollectionReportList",
      "getFilmCollectionReportToDate",
      "getFilmCollectionReportFromDate",
      // Get DropDown Selected Values
      "getFilmCollectionReportSelectedDistributor",
      "getFilmCollectionReportSelectedCinema",
      "getFilmCollectionReportSelectedMovie",
      // EXCEL
      "getFilmCollectionExcelFileName",

      // PDF
      "getFilmCollectionPDFFileName"
    ])
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.onFilmCollectionReportFlagHandler({
      event: null,
      name: "isCinema",
      value: cinemaId
    });
    this.onFilmCollectionReportFlagHandler({
      event: null,
      name: "isCountry",
      value: this.secureStore.get("BRGLOPCO") || null
    });
    this.fetchCinemasList({ cinemaId });
    this.fetchDistributorsList();

    this.fetchDistributorsActiveMasterMovie();
  },
  mounted() {},
  methods: {
    ...mapActions([
      //
      "fetchCinemasList",
      "fetchDistributorsList",
      "fetchDistributorsActiveMasterMovie",
      //
      "fetchFilmCollectionReportListv2",
      "onFilmCollectionReportDateHandler",
      "onFilmCollectionReportDropdownHandler",
      "onFilmCollectionReportFlagHandler",
      // RESET STORE
      "onResetFilmCollectionReportStoreState"
    ])
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getFilmCollectionExcelFileName
    });
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getFilmCollectionPDFFileName
    });
    await this.onResetFilmCollectionReportStoreState();
  }
};
</script>
<style>
.swc-report-table th,
.swc-report-table td {
  padding: 5px 15px 5px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileDashboard/filmWiseCollectionReport.vue